module.exports = __webpack_public_path__ + "static/media/Chapter04.1073a021.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/assets/Chapter04.jpg
// module id = 244
// module chunks = 0